import React, {Component} from 'react';
import classnames from 'classnames';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import VimeoUploader from './VimeoUploader';
import YoutubeUploaderRedux from './YoutubeUploaderRedux';
import { injectIntl } from 'react-intl';
import {messages} from  './common/Translations';

import '../../scss/video-uploader.scss';

class VideoUpload extends React.Component {

    constructor(props) {
        super(props);

        let selectedOption = (this.props.youtubeId.input.value) ? 'youtube' : ((this.props.vimeoId && this.props.vimeoId.input.value) ? 'vimeo' : 'youtube');
        this.state = {selectedOption: selectedOption};
        this.handleOptionClick = this.handleOptionClick.bind(this);
    }

    handleOptionClick(event, option) {
        this.setState({selectedOption: option});
    }

    renderYouTube() {
        let {
            youtubeId,
            youtubeText
        } = this.props;
        if(this.state.selectedOption === 'youtube') {
            return (
                <YoutubeUploaderRedux
                    youtubeId={youtubeId}
                    text={youtubeText}
                />
            );
        }
    }

    renderVimeo() {
        if(this.state.selectedOption === 'vimeo') {
            let {
                vimeoId,
                vimeoName,
                vimeoDescription,
                companyId
            } = this.props;

            return(<VimeoUploader
                vimeoId={vimeoId}
                vimeoName={vimeoName}
                vimeoDescription={vimeoDescription}
                companyId={companyId}
            />);
        }
    }

    render() {
        return (
            <div>
                <div className="form-group row">
                    <label className="col-sm-2 col-form-label"><b>{this.props.intl.formatMessage(messages.selectVideoSource)}</b></label>
                    <div className="col-sm-10">
                        <Nav tabs role="tablist">
                            <NavItem>
                                <NavLink
                                    role="tab"
                                    className={classnames({ active: this.state.selectedOption === 'youtube' })}
                                    onClick={() => { this.setState({selectedOption: 'youtube'}); }}
                                >
                                <i data-cy-youtube-tab className="fa fa-youtube"/> YouTube
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: this.state.selectedOption === 'vimeo' })}
                                    onClick={() => { this.setState({selectedOption: 'vimeo'}) }}
                                >
                                    <i data-cy-vimeo-tab className="fa fa-vimeo"/> Vimeo
                                </NavLink>
                            </NavItem>
                        </Nav>
                    </div>
                </div>
                <TabContent activeTab={this.state.selectedOption}>
                    <TabPane tabId="youtube">
                        {this.renderYouTube()}
                    </TabPane>
                    <TabPane tabId="vimeo">
                        {this.renderVimeo()}
                    </TabPane>
                </TabContent>
            </div>
        );
    }
}

export default injectIntl(VideoUpload);


// WEBPACK FOOTER //
// ./web/src/components/VideoUploadRedux.jsx